/*
This is a forked version of https://github.com/morishitter/picostyle
*/
let _id = 0;
// Append the styles to the body instead of the head to avoid getting clobbered by Webflow
const { sheet } = document.body.appendChild(document.createElement('style'));

function hyphenate(str) {
  return str.replace(/[A-Z]/g, '-$&').toLowerCase();
}

function createStyle(rules, prefix) {
  const id = `p${_id++}`;
  const name = prefix + id;
  rules.forEach((rule) => {
    if (/^@/.test(rule)) {
      const start = rule.indexOf('{') + 1;
      rule = rule.slice(0, start) + name + rule.slice(start);
    } else {
      rule = name + rule;
    }
    sheet.insertRule(rule, sheet.cssRules.length);
  });
  return id;
}

function wrap(stringToWrap, wrapper) {
  return `${wrapper}{${stringToWrap}}`;
}

function parse(obj, isInsideObj) {
  const arr = [''];
  isInsideObj = isInsideObj || 0;
  for (var prop in obj) {
    let value = obj[prop];
    prop = hyphenate(prop);
    // Same as typeof value === 'object', but smaller
    if (!value.sub && !Array.isArray(value)) {
      // replace & in "&:hover", "p>&"
      prop = prop.replace(/&/g, '');
      arr.push(wrap(parse(value, 1 && !/^@/.test(prop)).join(''), prop));
    } else {
      value = Array.isArray(value) ? value : [value];
      value.forEach(value => (arr[0] += `${prop}:${value};`));
    }
  }
  if (!isInsideObj) {
    arr[0] = wrap(arr[0], '');
  }
  return arr;
}

export default function (h, options) {
  const cache = {};
  options = options || {};
  return options.returnObject ? { style, css } : style;
  function style(nodeName) {
    return function (decls) {
      return function (attributes) {
        attributes = attributes || {};
        const nodeDecls = typeof decls === 'function' ? decls(attributes) : decls;
        attributes.class = [css(nodeDecls), attributes.class]
          .filter(Boolean)
          .join(' ');
        return h(nodeName, attributes);
      };
    };
  }
  function css(decls) {
    const rules = parse(decls);
    const key = rules.join('');
    return cache[key] || (cache[key] = createStyle(rules, '.'));
  }
}

export function keyframes(obj) {
  const rule = wrap(parse(obj, 1).join(''), '');
  return createStyle([rule], '@keyframes ');
}
